import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Lock, Sparkles } from "lucide-react";

/**
 * <PaywallGate module="outreach">
 *   <FullOutreachApp />
 * </PaywallGate>
 *
 * If the current user's plan doesn't unlock `module`, renders <UpgradeCTA>
 * instead. Otherwise renders children.
 */
export default function PaywallGate({ module, children, hasModule, planId }) {
    if (hasModule) return children;
    return (
        <div className="max-w-2xl mx-auto py-16 px-6">
            <UpgradeCTA required_module={module} current_plan={planId} />
        </div>
    );
}

export function UpgradeCTA({ required_module, current_plan }) {
    const label = (required_module || "this feature").replace(/_/g, " ");
    return (
        <motion.div
            data-testid="upgrade-cta"
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            className="rounded-2xl border border-[var(--color-primary)]/30 bg-gradient-to-br from-[var(--color-panel-ai)] to-[var(--color-card)] p-8 text-center shadow-[0_0_0_1px_rgba(255, 255, 255,0.06)]"
        >
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[var(--color-primary)]/15 text-[var(--color-primary)]">
                <Lock className="h-6 w-6" />
            </div>
            <h2 className="mt-5 text-2xl font-semibold text-text-main">
                Sblocca <span className="capitalize">{label}</span>
            </h2>
            <p className="mt-2 text-sm text-text-secondary max-w-md mx-auto">
                Il tuo piano attuale{" "}
                <strong className="text-text-main">{current_plan || "free"}</strong> non
                include il modulo <strong className="text-text-main">{required_module}</strong>.
                Scegli un piano superiore per abilitarlo.
            </p>
            <div className="mt-6 flex justify-center gap-2">
                <Link
                    to="/app/subscription"
                    data-testid="upgrade-cta-view-plans"
                    className="inline-flex items-center gap-2 rounded-full bg-white hover:bg-[#EDEDED] px-5 py-2.5 text-sm font-medium text-black hover:opacity-90 transition"
                >
                    <Sparkles className="h-4 w-4" />
                    Vedi i piani
                </Link>
                <Link
                    to="/app/dashboard"
                    className="inline-flex items-center gap-2 rounded-full border border-[var(--color-border)] px-5 py-2.5 text-sm text-text-secondary hover:text-text-main hover:border-text-secondary/40 transition"
                >
                    Torna alla dashboard
                </Link>
            </div>
        </motion.div>
    );
}
